import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { GenericLabelValue } from "src/app/shared/models/DTO/GenericLabelValue.dto";
import { ChartLegendPosition } from "src/app/shared/models/enums/ChartLegendPosition.enum";
import { SalesSummary } from "src/app/shared/models/SalesSummary.model";

@Component({
	selector: "app-sales-dash",
	templateUrl: "./sales-dash.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class SalesDashComponent implements OnInit, OnChanges {
	@Input() checkDate: string;
	@Output() checkDateChange = new EventEmitter<string>();

	@Input() currentDaySalesSummary: SalesSummary;
	@Output() currentDaySalesSummaryChange = new EventEmitter<SalesSummary>();

	metrics = {
		checkCount: 0,
		checkCountPercent: 0,
		averageCheck: 0,
		averageCheckPercent: 0,
		netSales: 0,
		netSalesPercent: 0,
		recordsRemaining: 0,
		lastCheckDate: undefined,
		loadComplete: false,
	};

	salesAndLaborChart = {
		options: undefined,
		data: undefined,
	};

	salesGuestViewOption: GenericLabelValue[] = [
		{
			label: "sales",
			value: "sales",
		},
		{
			label: "guest avg",
			value: "guests",
		},
		{
			label: "check avg",
			value: "checkAverage",
		},
	];
	salesGuestViewSelected: string = "sales";

	orderTypeMealPeriodOption: GenericLabelValue[] = [
		{
			label: "order type",
			value: "orderType",
		},
		{
			label: "meal period",
			value: "mealPeriod",
		},
	];
	orderTypeMealPeriodViewSelected: string = "orderType";

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.buildSalesAndLaborChart();
		this.calculateMetrics();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.currentDaySalesSummary && this.currentDaySalesSummary?.checkDate) {
			this.buildSalesAndLaborChart();
			this.calculateMetrics();
		}
		if (changes.checkDate) {
			this.metrics.loadComplete = false;
		}
	}

	async buildSalesAndLaborChart() {
		const data = {
			labels: ["Sales", "Labor"],
			datasets: [
				{
					data: [this.currentDaySalesSummary?.netSales, this.currentDaySalesSummary?.laborCost],
					backgroundColor: [this.app.references.colorPallete.primary, this.app.references.colorPallete.secondary],
					hoverBackgroundColor: [
						this.app.references.transparentize(this.app.references.colorPallete.primary, 0.75),
						this.app.references.transparentize(this.app.references.colorPallete.secondary, 0.75),
					],
				},
			],
		};

		this.salesAndLaborChart.options = this.app.references.chartConfig(ChartLegendPosition.BOTTOM, false, false);
		this.salesAndLaborChart.data = data;
	}

	async calculateMetrics() {
		this.metrics.loadComplete = false;
		const currentDaySummary = this.venueService.salesSummaryList.value.find((i) => i.checkDate === this.checkDate);
		if (currentDaySummary && currentDaySummary.averages) {
			this.metrics.averageCheck = currentDaySummary.averages.averageCheck;
			this.metrics.averageCheckPercent = currentDaySummary.averageCheck / this.metrics.averageCheck;

			this.metrics.checkCount = currentDaySummary.checkCount;
			this.metrics.checkCountPercent = currentDaySummary.checkCount / this.metrics.checkCount;

			this.metrics.netSales = currentDaySummary.netSales;
			this.metrics.netSalesPercent = currentDaySummary.netSales / this.metrics.netSales;
		}

		this.metrics.loadComplete = true;
	}
}
